export enum LoginViewError {
  REGISTRATION_LINK_FETCH_FAILED = 'registration_link_fetch_failed',
  /**
   * User exists on user db but user email is not confirmed yet
   */
  USER_NOT_CONFIRMED = 'user_not_confirmed',
  INVALID_CREDENTIALS = 'invalid_credentials',
  REGISTRATION_CANCELLED = 'registration_cancelled',
  /**
   * registration callback result: generic error on registration
   */
  REGISTRATION_FAILED = 'registration_failed',
  /**
   * registration callback result: Username is already registered
   */
  USER_ALREADY_REGISTERED = 'user_already_registered',
  /**
   * registration callback result: No tenant found for the user
   */
  NO_TENANT_FOUND = 'no_tenant_found',
  GENERIC_ERROR = 'generic_error',
  LOGIN_EXPIRED = 'login_expired',
  /**
   * registration callback result: the OAuth flow was started on a different
   * address (e.g. raw ECS url) than the configured callback domain, so the
   * state cookie is missing. The user should restart from the correct address.
   */
  WRONG_DOMAIN = 'wrong_domain',
}
